import * as React from 'react';
const AiVoiceIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 3.5A.5.5 0 0 1 8 4v12a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5M5 4.833a.5.5 0 0 1 .5.5v9.334a.5.5 0 0 1-1 0V5.333a.5.5 0 0 1 .5-.5m5 0a.5.5 0 0 1 .5.5v9.334a.5.5 0 0 1-1 0V5.333a.5.5 0 0 1 .5-.5m5 2a.5.5 0 0 1 .5.5v5.334a.5.5 0 0 1-1 0V7.333a.5.5 0 0 1 .5-.5M2.5 8.167a.5.5 0 0 1 .5.5v2.666a.5.5 0 1 1-1 0V8.667a.5.5 0 0 1 .5-.5m10 0a.5.5 0 0 1 .5.5v2.666a.5.5 0 1 1-1 0V8.667a.5.5 0 0 1 .5-.5m5 0a.5.5 0 0 1 .5.5v2.666a.5.5 0 1 1-1 0V8.667a.5.5 0 0 1 .5-.5"
      fill="currentColor"
    />
  </svg>
);
export default AiVoiceIcon;
